import Vue from 'vue';
import i18n from '@/plugins/i18n';

const notify = ({ group, title, message, type }) => {
  Vue.notify({
    group,
    title,
    text: message,
    type,
  });
};

export const notifySuccess = (message, title) => {
  notify({ title, message, type: 'success' });
};

export const notifyError = ({ title, message }) => {
  notify({ title, message, type: 'error' });
};

export const notifyWarn = ({ title, message, action }) => {
  notify({
    title,
    message,
    type: 'warn',
  });
};


export const notifyGeneralError = (error) => {
  const title = i18n.t('notification.error-text');
  const message = error.details.message ? error.details.message : i18n.t('notification.error', { attribute: error?.httpStatusCode });
  notify({ title, message, type: 'error' });
};
